export const addressesDemo = [
    /* cspell:disable */
    {
        uuid: '82hdumid6',
        value: 'address-1',
        name: 'António',
        lastName: 'Rodrigues',
        fiscalNumber: '000000000',
        phoneNumber: '910000000',
        address: 'Parque Empresarial de Eiras, Lote 22',
        postalCode: '3020–430 Coimbra',
        region: 'Portugal',
    },
    {
        uuid: '82hdumid5',
        value: 'address-2',
        initiallySelected: true,
        name: 'Márcia',
        lastName: 'Meneses',
        fiscalNumber: '000000000',
        phoneNumber: '920000000',
        address: 'Rua das Beiras, 2º esq.',
        postalCode: '3020–432 Coimbra',
        region: 'Portugal',
    },
    {
        uuid: '82hdumid4',
        value: 'address-3',
        name: 'António',
        lastName: 'Rodrigues',
        fiscalNumber: '000000000',
        phoneNumber: '910000000',
        address: 'Rua das Beiras, 2º esq.',
        postalCode: '3020–432 Coimbra',
        region: 'Portugal',
    },
    /* cspell:enable */
];
